import React from 'react';

const LicenseIcon = ({ isActive }) => {
  return (
    <svg
      width='30'
      height='30'
      viewBox='0 0 32 32'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M20.0987,22.2223c1.0124-.8642,1.8519-2.0494,2.0741-3.6543.8395-.5679,1.7778-1.9506,2-2.963.2963-1.358.3704-2.3704-.4938-2.716-.1482-.0494-.2716-.0988-.4198-.1235-.4197-3.20987-2.4691-5.82715-5.1852-6.74073.2223-.34568.5433-.66667.963-.88889-.6173-.07408-1.5555-.02469-2.2716.54321-.9876-.98766-2.6667-.93827-3.8272-.74074.5186.24691.8889.59259,1.1358,1.01234-2.7901.8642-4.93823,3.53087-5.35798,6.79011-.12346.0247-.2716.0741-.41975.1235-.8642.3456-.79013,1.358-.49383,2.716.22222,1.0124,1.16049,2.3951,2,2.963.19753,1.5802,1.06176,2.7654,2.04936,3.6296-.395.6667-1.0123,1.1852-1.87652,1.5309-.37037.1234-.74074.2222-1.08642.3457-.02469,0-.07407.0246-.09877.0246-1.53086.4445-2.88888.8149-3.95061,1.3087C7.53084,28.5433,11.5308,30.568,15.9753,30.568c4.4691,0,8.4691-2.0247,11.1358-5.1852-1.358-.6667-3.2099-1.0617-5.3087-1.7531-.7654-.321-1.3333-.7901-1.7037-1.4074Z'
        stroke={isActive ? '#ffffffa3' : '#525876'}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default LicenseIcon;
